import { ZipOperator } from './zip';
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */
export function zipAll(project) {
    return this.lift(new ZipOperator(project));
}
//# sourceMappingURL=zipAll.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs-es/operator/zipAll.js
// module id = 341
// module chunks = 4